import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Provider } from "react-redux";
import store from "./redux/store";
import UIContextProvider from "./Context/UIContextProvider";
import { HelmetProvider } from "react-helmet-async";
import "./i18n";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("app");
const root = createRoot(rootElement);

root.render(
  <BrowserRouter basename={baseUrl}>
    <HelmetProvider>
      <Provider store={store}>
        <UIContextProvider>
          <App />
        </UIContextProvider>
      </Provider>
    </HelmetProvider>
  </BrowserRouter>,
);

serviceWorkerRegistration.unregister();
